import withMobilePromoListProps from 'viewModel/checkout/promoSection/mobilePromoList/withMobilePromoListProps';

import MobilePromoList from 'components/Checkout/PromoSection/MobilePromoList/MobilePromoList';

export default withMobilePromoListProps(MobilePromoList);
